/**
 * Cut app — /apps/cut/*
 *
 * One job: S2 cut-line. Order candidates, draw the cut, save the whole list as
 * a durable item pool with the cut line in place. No Event Designer, no
 * ranking session required.
 */

import { Navigate, Route, Routes } from 'react-router-dom';
import { getAppDefinition } from '../registry';
import { RequireAppAccess } from '../RequireAppAccess';
import CutHomeScreen from './CutHomeScreen';
import NewCutScreen from './NewCutScreen';

export default function CutApp() {
  const app = getAppDefinition('cut')!;
  return (
    <RequireAppAccess app={app}>
      <Routes>
        <Route index element={<CutHomeScreen />} />
        <Route path="new" element={<NewCutScreen />} />
        <Route path="*" element={<Navigate to="/apps/cut" replace />} />
      </Routes>
    </RequireAppAccess>
  );
}
